/**
 * Facility-specific floor prefixes trimmed off a location label before it is shown. These are values
 * from one facility's location naming, not app concepts — centralized here so the display path has a
 * single definition instead of the literals being re-typed at every render site (where they had already
 * drifted: "2ND FLOOR -" left a leading space while "3RD FLOOR - " did not).
 */
const DISPLAY_STRIPPED_LOCATION_PREFIXES = ["2ND FLOOR -", "3RD FLOOR -"];

/**
 * A location label with any known floor prefix trimmed for display.
 *
 * Returns "" when there is no location — an unassigned shift is a valid domain state, not an error, and
 * every call site renders this straight into JSX where empty means "show nothing".
 */
export const formatLocationLabel = (location: string | null | undefined): string => {
	if (!location) return "";
	for (const prefix of DISPLAY_STRIPPED_LOCATION_PREFIXES) {
		if (location.startsWith(prefix)) return location.slice(prefix.length).trim();
	}
	return location;
};
